<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>SAP Integration</h1>
      <v-row>
         <v-col class="my-0 py-0" xs="12" sm="12" md="4" cols="12">
          <v-text-field
            label="FTP Host"
            v-model="config.ftpHost"
            :disabled="!onEdit"
            autocomplete="off"
          ></v-text-field>
        </v-col>
        <v-col class="my-0 py-0" xs="12" sm="12" md="4" cols="12">
          <v-text-field
            label="Folder"
            v-model="config.path"
            :disabled="!onEdit"
            autocomplete="off"
          ></v-text-field>
        </v-col>
        <v-col class="my-0 py-0" sm="12" md="4" xs="12" cols="12">
          <v-text-field
            label="FTP User"
            v-model="config.ftpUser"
            :disabled="!onEdit"
            autocomplete="off"
          ></v-text-field>
        </v-col>
        <v-col class="my-0 py-0" sm="12" md="4" xs="12" cols="12">
          <v-text-field
            label="FTP  Password"
            v-model="config.ftpPassword"
            :type="showPassword ? 'text' : 'password'"
            autocomplete="off"
            :disabled="!onEdit"
          >
            <template slot="append">
              <v-icon @click.stop="showPassword = !showPassword">{{
                showPassword ? "mdi-eye" : "mdi-eye-off"
              }}</v-icon>
            </template>
          </v-text-field>
        </v-col>
        <v-col class="my-0 py-0" sm="12" md="4" xs="12" cols="12">
          <v-text-field
            label="FTP Port"
            v-model="config.ftpPort"
            :disabled="!onEdit"
            autocomplete="off"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="my-0 py-0">
          <v-btn
            class="mx-2"
            color="info"
            @click.stop="onEdit = true"
            :disabled="onEdit"
            >Edit</v-btn
          >
          <v-btn class="mx-2" :disabled="!onEdit" @click.stop="cancel"
            >Cancel</v-btn
          >
          <v-btn
            class="mx-2"
            color="success"
            :disabled="!onEdit"
            @click.stop="update"
            :loading="isUpdating"
            v-if="userAccess.update >= 1 || userAccess.add >= 1"
            >Update</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import isEmpty from "lodash/isEmpty";
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/sapConfig";
export default {
  metaInfo: {
    title: "SAP Integration",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  data: () => ({
    onEdit: false,
    isUpdating: false,
    config: {},
    showPassword: false
  }),
  methods: {
    getSapConfig() {
      this.$axios.get(`${API_ENDPOINT}`)
        .then(({ data }) => {
          if(!isEmpty(data)) {
            this.config = data;
          }
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
    },
    update() {
      this.isUpdating = true;
      this.$axios
        .post(`${API_ENDPOINT}`, this.config)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.onEdit = false;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    cancel() {
      this.onEdit = false;
      this.getSapConfig();
    }
  },
  created() {
    this.getSapConfig();

    this.getUserAccessRights("SAPInt");
  }
};
</script>